import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _1_45tracking_45redirect_45global from "/app/middleware/1.trackingRedirect.global.js";
import auth_45global from "/app/middleware/auth.global.js";
import staging_45global from "/app/middleware/staging.global.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _1_45tracking_45redirect_45global,
  auth_45global,
  staging_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-backhauls-ff": () => import("/app/middleware/checkBackhaulsFF.js"),
  "check-bundle-ff": () => import("/app/middleware/checkBundleFF.js"),
  "check-carrier-profile-ff": () => import("/app/middleware/checkCarrierProfileFF.js"),
  "check-enclosed-ff": () => import("/app/middleware/checkEnclosedFF.js"),
  "check-eta-update-ff": () => import("/app/middleware/checkEtaUpdateFF.js"),
  "check-filter-by-bundles-ff": () => import("/app/middleware/checkFilterByBundlesFF.js"),
  "check-increase-bundle-limit-ff": () => import("/app/middleware/checkIncreaseBundleLimitFF.js"),
  "check-map-ff": () => import("/app/middleware/checkMapFF.js"),
  "check-pending-offer-ff": () => import("/app/middleware/checkPendingOfferFF.js"),
  "check-saved-search-ff": () => import("/app/middleware/checkSavedSearchFF.js"),
  "check-url-for-job-ids": () => import("/app/middleware/checkUrlForJobIds.js"),
  "edit-job": () => import("/app/middleware/editJob.js"),
  "get-carrier-fleet": () => import("/app/middleware/getCarrierFleet.js"),
  "get-carrier-users": () => import("/app/middleware/getCarrierUsers.js"),
  "get-recommended-jobs-from-url": () => import("/app/middleware/getRecommendedJobsFromUrl.js"),
  "manage-jobs": () => import("/app/middleware/manageJobs.js"),
  "validate-user-account-level": () => import("/app/middleware/validateUserAccountLevel.js"),
  "validate-user-role": () => import("/app/middleware/validateUserRole.js")
}